import { Injectable } from '@angular/core';
import { GeneratedGameSave, GeneratedUpdateGameSave } from '@repo/backend-api-spec';
import { lastValueFrom } from 'rxjs';
import { BaseAPI, BaseRequestOptions } from './base-api';

@Injectable({
  providedIn: 'root',
})
export abstract class GameSaveApiService extends BaseAPI {
  /** Sent along with every request, e.g. for a subclass that authenticates differently. */
  protected readonly requestOptions?: Pick<BaseRequestOptions, 'headers' | 'context'>;

  public async getGameSave(userUid: string) {
    return await lastValueFrom(this.get<GeneratedGameSave>(`/savegame/${userUid}`, this.requestOptions));
  }

  public async upsertGameSave(userUid: string, data: GeneratedUpdateGameSave) {
    return await lastValueFrom(
      this.put<GeneratedUpdateGameSave, GeneratedGameSave>(`/savegame/${userUid}`, {
        ...this.requestOptions,
        body: data,
      }),
    );
  }
}
